import type { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

import { ErrorHandler, inject, Injectable, InjectionToken } from '@angular/core';

export const BugsnagHandler = new InjectionToken<BugsnagErrorHandler>('BugsnagHandlerToken');

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  readonly #bugsnagHandler = inject(BugsnagHandler);

  handleError(error: any): void {
    this.#bugsnagHandler.handleError(error);
  }
}
